import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const Folder = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
    >
      <g fill="currentColor" fillRule="nonzero">
        <path
          d="M11.33 5c.865 0 1.596.584 1.842 1.388h5.875c1.002 0 1.825.785 1.92 1.788l.005.054.003.052.004.1.005.175.005.221.004.305.004.639.002.517v.028l.001.028V17c0 1.094-.848 1.983-1.9 2l-.032.001H5.932c-.785 0-1.46-.484-1.762-1.18-.11-.193-.17-.43-.17-.72V6.983C4 5.888 4.864 5 5.93 5h5.4zm7.738 4.495H5.932c-.42 0-.76.345-.773.777V16.999c0 .407.294.744.674.794H19.111c.029 0 .058-.001.086-.005.245-.042.45-.204.56-.425.037-.085.059-.18.062-.279v-6.79c0-.066-.008-.13-.024-.19v-.081c-.105-.3-.378-.517-.701-.528h-.026zM11.331 6.19H5.929c-.418 0-.758.342-.771.769V8.46c.223-.1.468-.16.725-.166H19.068c.257 0 .503.051.727.146v-.267c-.084-.335-.375-.584-.724-.595h-6.749l-.255-.834c-.097-.319-.382-.543-.71-.554h-.026z"
          transform="translate(-378 -388) translate(290 24) translate(22 200) translate(2 96) translate(0 48) translate(64 20)"
        />
      </g>
    </svg>
  );
};

Folder.defaultProps = {
  width: '24px',
  height: '24px',
  style: {},
};

export default Folder;
